import { useEffect, useState } from "react";
import Reactions from "../components/Reactions";
import "react-quill/dist/quill.snow.css";

export default function ArticlePreview() {
  const [article, setArticle] = useState(null);

  useEffect(() => {
    const data = localStorage.getItem("article_preview");
    if (data) setArticle(JSON.parse(data));
  }, []);

  if (!article) {
    return <div className="p-10 text-center">No preview data</div>;
  }

  // ================= CLEAN CONTENT =================
  const cleanContent = article.content
    // remove empty paragraphs & nbsp
    .replace(/<p>(&nbsp;|\s)*<\/p>/gi, "")
    // remove <p><br></p>
    .replace(/<p><br\s*\/?><\/p>/gi, "")
    // collapse multiple <br>
    .replace(/(<br\s*\/?>\s*){2,}/gi, "<br>");

  return (
    <div className="max-w-4xl mx-auto p-6">

      <span className="bg-black text-white text-xs px-3 py-1 rounded">
        {article.category}
      </span>

      <h1 className="text-4xl font-bold mt-4">
        {article.title}
      </h1>

      {article.images && (
        <img
          src={article.images}
          alt={article.title}
          className="w-full mt-6 rounded max-h-[380px] object-cover"
        />
      )}

      {/* ================= CONTENT PREVIEW ================= */}
      <div
        className="prose prose-lg mt-8 max-w-full"
        dangerouslySetInnerHTML={{ __html: cleanContent }}
      />

      <Reactions initial={{}} />

      {/* PREVIEW NOTICE */}
      <div className="mt-10 text-center text-sm text-gray-500 border-t pt-4">
        ⚠️ This is a preview. Content is not published.
      </div>

      {/* ================= LOCAL STYLE FIX (PREVIEW ONLY) ================= */}
      <style>{`
        .article-preview-content p {
          margin: 0.45rem 0 !important;
          line-height: 1.65 !important;
        }

        .article-preview-content p:empty,
        .article-preview-content p > br {
          display: none !important;
        }

        .article-preview-content ul {
          margin: 0.5rem 0 !important;
          padding-left: 1.25rem;
        }

        .article-preview-content li {
          margin: 0.25rem 0 !important;
        }

        .article-preview-content h2 {
          font-size: 1.4rem;
          margin-top: 1.2rem;
          margin-bottom: 0.4rem;
          font-weight: 700;
        }

        .article-preview-content h3 {
          font-size: 1.1rem;
          margin-top: 0.9rem;
          margin-bottom: 0.3rem;
          font-weight: 600;
        }
      `}</style>
    </div>
  );
}
